export const CHANGE_PASS_SUCCESS = 'Senha alterada com sucesso';
export const CHANGE_PROFILE_SUCCESS = 'Perfil alterado com sucesso';
export const CHANGE_PROFILE_ERROR = 'Falha ao atualizar os dados do perfil';
export const REMOVE_PROFILE_PREMIUM_ASK =
  'Deseja retirar usuário da opção premium?';
export const ADD_USER_PREMIUM_ASK = 'Deseja tornar usuário premium?';
